import React from "react";
import { FaArrowLeft } from "react-icons/fa";
import styles from "./styles/EducationViewAll.module.css";

const EducationViewAll = ({ onClose, onSelectTag }) => {
    const sections = [
        {
            title: "By Grade",
            tags: ["Elementary", "Middle School", "High School", "College"],
        },
        {
            title: "By Subject",
            tags: [
                "Math", "English", "Reading", "Grammar", "Physics",
                "Chemistry", "Biology", "History", "Statistics",
                "Computer Science", "Economics",
            ],
        },
        {
            title: "Test Prep",
            tags: ["SAT", "ACT", "GRE", "AP"],
        },
    ];

    return (
        <div className={styles.modalOverlay} onClick={onClose}>
            <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                <div className={styles.headerBar}>
                    <button onClick={onClose} className={styles.backButton}>
                        <FaArrowLeft />
                    </button>
                    <h1 className={styles.header}>Education</h1>
                </div>
                {sections.map((section) => (
                    <div key={section.title} className={styles.section}>
                        <h2 className={styles.sectionTitle}>{section.title}</h2>
                        <div className={styles.tagsRow}>
                            {section.tags.map((tag) => (
                                <button
                                    key={tag}
                                    className={styles.tagButton}
                                    onClick={() => onSelectTag(tag)}
                                >
                                    {tag}
                                </button>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default EducationViewAll;